import {Component, OnInit, OnDestroy,ViewChild} from '@angular/core';
import {MessageService} from '../message.service';
import {CustomInputEditor} from '../custom-inputEditor';
import {NotifierService} from 'angular-notifier';
import {Editors, Filters, Formatters,OnEventArgs} from 'angular-slickgrid';
import {Router} from '@angular/router';
import {RestApiService} from '../rest-api.service';
import {NgbModal ,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {FormControl} from '@angular/forms';
import {Subscription} from 'rxjs';
// import {bool} from 'aws-sdk/clients/signer';
import {error} from 'selenium-webdriver';

@Component({
    selector: 'app-support-group',
    templateUrl: './support-group.component.html',
    styleUrls: ['./support-group.component.css']
})
export class SupportGroupComponent implements OnInit, OnDestroy {

    displayed = true;
    groupName: string;
    description: string;

    zoneSelected: string;
    clientId: number;
    zones = [];
    parents = [];
    parentSelected: number;
    hourStart = '';
    hourEnd = '';
    searchTerm: FormControl = new FormControl();

    days = [];
    sunChck: boolean;
    sunHourStart: any;
    sunHourEnd: any;
    monChck: any;
    tueChck: any;
    monHourStart: any;
    monHourEnd: any;
    tueHourStart: any;
    tueHourEnd: any;
    wedChck: any;
    wedHourStart: any;
    wedHourEnd: any;
    thurChck: any;
    thurHourEnd: any;
    thurHourStart: any;
    friChck: any;
    friHourStart: any;
    friHourEnd: any;
    satChck: any;
    satHourStart: any;
    satHourEnd: any;
    hourChecked = false;
    groupEmail: string;

    isLoading = false;

    add = false;
    del = false;
    edit = false;
    view = false;

    displayData: any;

    isError = false;
    errorMessage: string;
    respObject: any;
    totalData: number;
    nextOffset: number;
    previousOffset: number;
    collectionSize: number;
    pageSize: number;
    paginationType: string;
    page_no: number;
    totalPage: number;
    private baseFlag: any;
    private userAuth: Subscription;
    private notifier: NotifierService;
    groupLevel: string;
    snrMngmnt: boolean;
    offset: number;
    dataLoaded: boolean;
    showExportBtn: boolean;
    dataExcel = [];
    nameSelected: any;
    supprt: any;
    showSearch = true;


    isExportDisable = false;
    private modalReference: NgbModalRef;
    selectedId: number;
    supp_Daytime_id:any;
    @ViewChild('content1') private content1;




    @ViewChild('scarch_content') private scarch_content;
    private searchModalReference: NgbModalRef;
    hours =[];
    mins=[];
    sunHoursStart:any;
    sunMinsStart:any;
    sunHoursEnd:any;
    sunMinsEnd:any;
    monHoursStart:any;
    monMinsStart:any;
    monHoursEnd:any;
    monMinsEnd:any;
    tueHoursStart:any;
    tueMinsStart:any;
    tueHoursEnd:any;
    tueMinsEnd:any;
    wedHoursStart:any;
    wedMinsStart:any;
    wedHoursEnd:any;
    wedMinsEnd:any;
    thurHoursStart:any;
    thurMinsStart:any;
    thurHoursEnd:any;
    thurMinsEnd:any;
    friHoursStart:any;
    friMinsStart:any;
    friHoursEnd:any;
    friMinsEnd:any;
    satHoursStart:any;
    satMinsStart:any;
    satHoursEnd:any;
    satMinsEnd:any;
    hoursStart:any;
    minsStart:any;
    hoursEnd:any;
    minsEnd:any;



    constructor(private _rest: RestApiService, private messageService: MessageService, private route: Router,
                private modalService: NgbModal, notifier: NotifierService) {
        this.notifier = notifier;
        this.messageService.getCellChangeData().subscribe(item => {
            // console.log(item);
            switch (item.type) {
                case 'change':
                    // console.log('changed');
                    if (!this.messageService.edit) {
                        this.notifier.notify('error', 'You do not have edit permission');
                    } else {
                        if (confirm('Are you sure?')) {
                            // console.log('item====' + JSON.stringify(item));
                        //     item.user_id = this.messageService.getUserId();
                        //     item.group_email = btoa(this.messageService.xorEncode(item.group_email, this.messageService.SECRET_TOKEN));
                        //     this._rest.updateSupportGrpLevel(item).subscribe((res) => {
                        //         this.respObject = res;
                        //         if (this.respObject.success) {
                        //             // console.log('data--Done');
                        //             this.notifier.notify('success', 'Updated successfully');
                        //         } else {
                        //             // console.log('data--Not---Done');
                        //             this.notifier.notify('error', this.respObject.errorMessage);
                        //         }
                        //     }, (err) => {
                        //         this.notifier.notify('error', JSON.stringify(err));
                        //     });
                        }
                    }
                    break;
                case 'delete':
                    // console.log('deleted');
                    if (!this.messageService.del) {
                        this.notifier.notify('error', 'You do not have delete permission');
                    } else {
                        if (confirm('Are you sure?')) {
                            // console.log(JSON.stringify(item));
                            this._rest.deleteSupportGrpLevel({id: item.id, user_id: this.messageService.getUserId()}).subscribe((res) => {
                                this.respObject = res;
                                if (this.respObject.success) {
                                    this.totalData = this.totalData - 1;
                                    this.messageService.setTotalData(this.totalData);
                                    this.messageService.sendAfterDelete(item.id);
                                } else {
                                    this.notifier.notify('error', this.respObject.errorMessage);
                                }
                            }, (err) => {
                                this.notifier.notify('error', JSON.stringify(err));
                            });
                        }
                    }
                    break;
            }
        });
        // this.messageService.getUserAuth().subscribe(details => {
        //   console.log(JSON.stringify(details));
        //   if (details.length > 0) {
        //     this.add = details[0].addFlag;
        //     this.del = details[0].deleteFlag;
        //     this.view = details[0].viewFlag;
        //     this.edit = details[0].editFlag;
        //   } else {
        //     this.add = true;
        //     this.del = true;
        //     this.view = true;
        //     this.edit = true;
        //   }
        // });
        this.searchTerm.valueChanges.subscribe(
            zone => {
                this.isLoading = true;
                this._rest.searchZone(zone).subscribe((res1) => {
                    this.respObject = res1;
                    this.isLoading = false;
                    if (this.respObject.success) {

                        this.isError = false;
                        this.zones = this.respObject.details;
                    } else {
                        this.isError = true;
                        this.errorMessage = this.respObject.errorMessage;
                    }
                }, (err) => {
                    this.isLoading = false;
                    this.isError = true;
                    this.errorMessage = this.messageService.SERVER_ERROR;
                });
            });
    }


    ngOnInit() {
        this.showExportBtn = true;
        this.dataLoaded = false;
        this.groupEmail = '';
        this.nextOffset = 0;
        this.previousOffset = 0;
        this.pageSize = this.messageService.pageSize;
        this.page_no = 0;
        this.totalPage = 0;
        // this.messageService.setGridWidth(4000);
        this.displayData = {
            pageName: 'Maintain Support Group',
            openModalButton: 'Add Support Group',
            searchModalButton: 'Search',
            breadcrumb: 'Supportgroup',
            folderName: 'All Support Group',
            tabName: 'Support Groups',
            exportBtn: 'Export to excel'
        };
        this.sunChck = false;
        this.monChck = false;
        this.tueChck = false;
        this.wedChck = false;
        this.thurChck = false;
        this.friChck = false;
        this.satChck = false;
        this.groupLevel = '1';
        for(let i=0;i<25;i++){
            if( i <= 9){
                this.hours.push("0"+i);
           }else{
                this.hours.push(''+i);
            }
        }

        for(let i=0;i<60;i++){
            if( i <= 9){
                this.mins.push("0"+i);
            }else{
                this.mins.push(''+i);
          }
        }

        // console.log(this.hours);

        this.days = [{id: 0, day: 'Sun', checked: false}, {id: 1, day: 'Mon', checked: false}, {id: 2, day: 'Tue', checked: false}, {
            id: 3,
            day: 'Wed',
            checked: false
        }, {id: 4, day: 'Thur', checked: false}, {
            id: 5,
            day: 'Fri', checked: false
        }, {id: 6, day: 'Sat', checked: false}];

        // this.zones = [{id: 0, zone: 'Select Time Zone'}, {id: 1, zone: 'Asia/Taipei'}, {id: 2, zone: 'Asia/Dubai'},
        //   {id: 3, zone: 'Australia/Perth'}];
        this.parents = [{id: 0, parent: 'Select Parent Group'}, {id: 1, parent: 'TestParent1'}, {id: 2, parent: 'TestParent2'},
            {id: 3, parent: 'TestParent3'}];
        this.parentSelected = 0;
        // this.zoneSelected = 0;
        const columnDefinitions = [
            {
                id: 'delete',
                field: 'id',
                excludeFromHeaderMenu: true,
                formatter: Formatters.deleteIcon,
                minWidth: 30,
                maxWidth: 30,
            },
            {
                id: 'edit',
                field: 'id',
                excludeFromHeaderMenu: true,
                formatter: Formatters.editIcon,
                minWidth: 30,
                maxWidth: 30,
                
                onCellClick: (e: Event, args: OnEventArgs) => {

                    console.log(args.dataContext);
                    this.supp_Daytime_id = args.dataContext.id ;
                    this.selectedId = args.dataContext.SupId;

                    this.groupName = args.dataContext.name;
                    this.description = args.dataContext.description;
                    this.groupLevel =  ""+args.dataContext.level;
                    this.zoneSelected = args.dataContext.zone;
                    this.snrMngmnt = args.dataContext.mngmntView;
                    this.groupEmail = args.dataContext.group_email;
                    this.sunChck = args.dataContext.sunChck;
                    this.monChck = args.dataContext.monChck;
                    this.tueChck = args.dataContext.tueChck;
                    this.wedChck = args.dataContext.wedChck;
                    this.thurChck = args.dataContext.thurChck;
                    this.friChck = args.dataContext.friChck;
                    this.satChck = args.dataContext.satChck;
                    if (this.sunChck) {
                        this.sunHourStart = args.dataContext.sunHourStart.split(':');
                        this.sunHoursStart = this.sunHourStart[0];
                        this.sunMinsStart = this.sunHourStart[1];
                        this.sunHourEnd = args.dataContext.sunHourEnd.split(':');
                        this.sunHoursEnd = this.sunHourEnd[0];
                        this.sunMinsEnd = this.sunHourEnd[1];                   



                        // this.sunHourStart = new Date(this.hourToTimestamp(args.dataContext.sunHourStart));
                        // this.sunHourEnd = new Date(this.hourToTimestamp(args.dataContext.sunHourEnd));

                    } else {

                        this.sunHoursStart = this.hours[0];
                        this.sunMinsStart = this.mins[0];
                        this.sunHoursEnd = this.hours[0];
                        this.sunMinsEnd = this.mins[0];
                

                        // this.sunHourStart = 0;
                        // this.sunHourEnd = 0;
                    }
                    if (this.monChck) {
                        this.monHourStart = args.dataContext.monHourStart.split(':');
                        this.monHoursStart = this.monHourStart[0];
                        this.monMinsStart = this.monHourStart[1];
                        this.monHourEnd = args.dataContext.monHourEnd.split(':');
                        this.monHoursEnd = this.monHourEnd[0];
                        this.monMinsEnd = this.monHourEnd[1];                   
                    } else {
                        this.monHoursStart = this.hours[0];
                        this.monMinsStart = this.mins[0];
                        this.monHoursEnd = this.hours[0];
                        this.monMinsEnd = this.mins[0];
                
                    }
                    if (this.tueChck) {
                        this.tueHourStart = args.dataContext.tueHourStart.split(':');
                        this.tueHoursStart = this.tueHourStart[0];
                        this.tueMinsStart = this.tueHourStart[1];
                        this.tueHourEnd = args.dataContext.tueHourEnd.split(':');
                        this.tueHoursEnd = this.tueHourEnd[0];
                        this.tueMinsEnd = this.tueHourEnd[1];                   



                        // this.tueHourStart = new Date(this.hourToTimestamp(args.dataContext.tueHourStart));
                        // this.tueHourEnd = new Date(this.hourToTimestamp(args.dataContext.tueHourEnd));
                    } else {
                        // this.tueHourStart = 0;
                        // this.tueHourEnd = 0;

                        this.tueHoursStart = this.hours[0];
                        this.tueMinsStart =this.mins[0];
                        this.tueHoursEnd = this.hours[0];
                        this.tueMinsEnd = this.mins[0];
                
                    }
                    if (this.wedChck) {
                        this.wedHourStart = args.dataContext.wedHourStart.split(':');
                        this.wedHoursStart = this.wedHourStart[0];
                        this.wedMinsStart = this.wedHourStart[1];
                        this.wedHourEnd = args.dataContext.wedHourEnd.split(':');
                        this.wedHoursEnd = this.wedHourEnd[0];
                        this.wedMinsEnd = this.wedHourEnd[1];                   


                        // this.wedHourStart = new Date(this.hourToTimestamp(args.dataContext.wedHourStart));
                        // this.wedHourEnd = new Date(this.hourToTimestamp(args.dataContext.wedHourEnd));
                    } else {
                        this.wedHoursStart = this.hours[0];
                        this.wedMinsStart = this.mins[0];
                        this.wedHoursEnd = this.hours[0];
                        this.wedMinsEnd = this.mins[0];
                    }
                    if (this.thurChck) {

                        this.thurHourStart = args.dataContext.thurHourStart.split(':');
                        this.thurHoursStart = this.thurHourStart[0];
                        this.thurMinsStart = this.thurHourStart[1];
                        this.thurHourEnd = args.dataContext.thurHourEnd.split(':');
                        this.thurHoursEnd = this.thurHourEnd[0];
                        this.thurMinsEnd = this.thurHourEnd[1];                   

                        // this.thurHourStart = new Date(this.hourToTimestamp(args.dataContext.thurHourStart));
                        // this.thurHourEnd = new Date(this.hourToTimestamp(args.dataContext.thurHourEnd));
                    } else {

                        this.thurHoursStart = this.hours[0];
                        this.thurMinsStart = this.mins[0];
                        this.thurHoursEnd = this.hours[0];
                        this.thurMinsEnd = this.mins[0];
                
                        // this.thurHourStart = 0;
                        // this.thurHourEnd = 0;
                    }
                    if (this.friChck) {
                        this.friHourStart = args.dataContext.friHourStart.split(':');
                        this.friHoursStart = this.friHourStart[0];
                        this.friMinsStart = this.friHourStart[1];
                        this.friHourEnd = args.dataContext.friHourEnd.split(':');
                        this.friHoursEnd = this.friHourEnd[0];
                        this.friMinsEnd = this.friHourEnd[1];                   



                        // this.friHourStart = new Date(this.hourToTimestamp(args.dataContext.friHourStart));
                        // this.friHourEnd = new Date(this.hourToTimestamp(args.dataContext.friHourEnd));
                    } else {


                        this.friHoursStart = this.hours[0];
                        this.friMinsStart = this.mins[0];
                        this.friHoursEnd = this.hours[0];
                        this.friMinsEnd = this.mins[0];
                
                        // this.friHourStart = 0;
                        // this.friHourEnd = 0;
                    }
                    if (this.satChck) {


                        this.satHourStart = args.dataContext.satHourStart.split(':');
                        this.satHoursStart = this.satHourStart[0];
                        this.satMinsStart = this.satHourStart[1];
                        this.satHourEnd = args.dataContext.satHourEnd.split(':');
                        this.satHoursEnd = this.satHourEnd[0];
                        this.satMinsEnd = this.satHourEnd[1];                   

                        // this.satHourStart = new Date(this.hourToTimestamp(args.dataContext.satHourStart));
                        // this.satHourEnd = new Date(this.hourToTimestamp(args.dataContext.satHourEnd));
                    } else {


                        this.satHoursStart = this.hours[0];
                        this.satMinsStart = this.mins[0];
                        this.satHoursEnd = this.hours[0];
                        this.satMinsEnd = this.mins[0];
                
                        // this.satHourStart = 0;
                        // this.satHourEnd = 0;
                    }
                    // this.dateStart = args.dataContext.startDate;
                    // // console.log("aaaaaaaaa"+this.dateStart);
                    // if (args.dataContext.endDate === null) {
                    //     this.slideChecked = !this.slideChecked;
                    // } else {
                    //     this.slideChecked = false;
                    //     this.dateEnd = args.dataContext.endDate;
                    // }
                    this.modalReference = this.modalService.open(this.content1, {});
                    this.modalReference.result.then((result) => {
                    }, (reason) => {

                    });
                }
            },

            // {id: 'id', name: 'Id', field: 'id',  minWidth: 100, sortable: true, filterable: true},
            {
                id: 'name', name: ' Name', field: 'name', minWidth: 100, sortable: true, filterable: true
                
            },
            {
                id: 'desc', name: 'Description', field: 'description', minWidth: 100, sortable: true, filterable: true,
                // cssClass: 'highlight',
                // editor: {
                //     model: CustomInputEditor,
                // }
            },
            {
                id: 'zone', name: 'Zone', field: 'zone', minWidth: 100, sortable: true, filterable: true,
                // editor: {
                // model: CustomInputEditor,
                // }
            },
            // {
            //   id: 'parent', name: 'Parent Group', field: 'parent', sortable: true, filterable: true, editor: {
            //     model: CustomInputEditor,
            //   }
            // },
            {
                id: 'sunChck', name: 'Sunday', field: 'sunChck', minWidth: 100, sortable: true, formatter: Formatters.checkmark,
                filter: {
                    collection: [{value: '', label: 'All'}, {value: true, label: 'True'}, {value: false, label: 'False'}],
                    model: Filters.singleSelect,

                    filterOptions: {
                        autoDropWidth: true
                    },
                }, filterable: true,
                // editor: {
                //   model: Editors.checkbox,
                // }
            },
            {
                id: 'sunHourStart',
                name: 'Sunday Hour Start',
                field: 'sunHourStart',
                sortable: true,
                filterable: true,
                minWidth: 100,
                // editor: {
                //   model: CustomInputEditor,
                // }
            },
            {
                id: 'sunHourEnd', name: 'Sunday Hour End', field: 'sunHourEnd', minWidth: 100, sortable: true, filterable: true,
                // editor: {
                // model: CustomInputEditor,
                // }
            },
            {
                id: 'monChck',
                name: 'Monday',
                field: 'monChck',
                sortable: true,
                filterable: true,
                minWidth: 100,
                formatter: Formatters.checkmark,
                filter: {
                    collection: [{value: '', label: 'All'}, {value: true, label: 'True'}, {value: false, label: 'False'}],
                    model: Filters.singleSelect,

                    filterOptions: {
                        autoDropWidth: true
                    },
                }
            },
            {
                id: 'monHourStart', name: 'Monday Hour Start', field: 'monHourStart', minWidth: 100, sortable: true, filterable: true,
                // editor: {
                // model: CustomInputEditor,
                // }
            },
            {
                id: 'monHourEnd', name: 'Monday Hour End', field: 'monHourEnd', minWidth: 100, sortable: true, filterable: true,
                // editor: {
                //   model: CustomInputEditor,
                // }
            },
            {
                id: 'tueChck',
                name: 'Tuesday',
                field: 'tueChck',
                sortable: true,
                minWidth: 100,
                filterable: true,
                formatter: Formatters.checkmark,
                filter: {
                    collection: [{value: '', label: 'All'}, {value: true, label: 'True'}, {value: false, label: 'False'}],
                    model: Filters.singleSelect,

                    filterOptions: {
                        autoDropWidth: true
                    },
                }
            },
            {
                id: 'tueHourStart', name: 'Tuesday Hour Start', minWidth: 100, field: 'tueHourStart', sortable: true, filterable: true,
                // editor: {
                //   model: CustomInputEditor,
                // }
            },
            {
                id: 'tueHourEnd', name: 'Tuesday Hour End', minWidth: 100, field: 'tueHourEnd', sortable: true, filterable: true,
                // editor: {
                //   model: CustomInputEditor,
                // }
            },
            {
                id: 'wedChck', name: 'Wednesday', field: 'wedChck', formatter: Formatters.checkmark,
                filter: {
                    collection: [{value: '', label: 'All'}, {value: true, label: 'True'}, {value: false, label: 'False'}],
                    model: Filters.singleSelect,

                    filterOptions: {
                        autoDropWidth: true
                    },
                }, sortable: true, filterable: true, minWidth: 40,
                // editor: {
                //   model: Editors.checkbox,
                // }
            },
            {
                id: 'wedHourStart', name: 'Wednesday Hour Start', field: 'wedHourStart', sortable: true, minWidth: 100, filterable: true,
                // editor: {
                //   model: CustomInputEditor,
                // }
            },
            {
                id: 'wedHourEnd', name: 'Wednesday Hour End', field: 'wedHourEnd', sortable: true, minWidth: 100, filterable: true,
                //  editor: {
                //   model: CustomInputEditor,
                // }
            },
            {
                id: 'thurChck', name: 'Thursday', field: 'thurChck', formatter: Formatters.checkmark,
                filter: {
                    collection: [{value: '', label: 'All'}, {value: true, label: 'True'}, {value: false, label: 'False'}],
                    model: Filters.singleSelect,

                    filterOptions: {
                        autoDropWidth: true
                    },
                }, sortable: true, filterable: true, minWidth: 40,
                //  editor: {
                //   model: Editors.checkbox,
                // }
            },
            {
                id: 'thurHourStart', name: 'Thursday Hour Start', field: 'thurHourStart', sortable: true, minWidth: 100, filterable: true,
                // editor: {
                //   model: CustomInputEditor,
                // }
            },
            {
                id: 'thurHourEnd', name: 'Thursday Hour End', field: 'thurHourEnd', sortable: true, minWidth: 100, filterable: true,
                //  editor: {
                //   model: CustomInputEditor,
                // }
            },
            {
                id: 'friChck', name: 'Friday', field: 'friChck', formatter: Formatters.checkmark,
                filter: {
                    collection: [{value: '', label: 'All'}, {value: true, label: 'True'}, {value: false, label: 'False'}],
                    model: Filters.singleSelect,

                    filterOptions: {
                        autoDropWidth: true
                    },
                }, sortable: true, filterable: true, minWidth: 40,
                //  editor: {
                //   model: Editors.checkbox,
                // }
            },
            {
                id: 'friHourStart', name: 'Friday Hour Start', field: 'friHourStart', sortable: true, filterable: true, minWidth: 100,
                // editor: {
                //   model: CustomInputEditor,
                // }
            },
            {
                id: 'friHourEnd', name: 'Friday Hour End', field: 'friHourEnd', sortable: true, filterable: true, minWidth: 100,
                // editor: {
                //   model: CustomInputEditor,
                // }
            },
            {
                id: 'satChck', name: 'Saturday', field: 'satChck', formatter: Formatters.checkmark,
                filter: {
                    collection: [{value: '', label: 'All'}, {value: true, label: 'True'}, {value: false, label: 'False'}],
                    model: Filters.singleSelect,

                    filterOptions: {
                        autoDropWidth: true
                    },
                }, sortable: true, filterable: true, minWidth: 40,
                // editor: {
                //   model: Editors.checkbox,
                // }
            },
            {
                id: 'satHourStart', name: 'Saturday Hour Start', field: 'satHourStart', sortable: true, filterable: true, minWidth: 100,
                // editor: {
                //   model: CustomInputEditor,
                // }
            },
            {
                id: 'satHourEnd', name: 'Saturday Hour End', field: 'satHourEnd', sortable: true, filterable: true, minWidth: 100,
                // editor: {
                //   model: CustomInputEditor,
                // }
            },
            {
                id: 'mngmntView', name: 'Management View', field: 'mngmntView', formatter: Formatters.checkmark,
                filter: {
                    collection: [{value: '', label: 'All'}, {value: true, label: 'True'}, {value: false, label: 'False'}],
                    model: Filters.singleSelect,

                    filterOptions: {
                        autoDropWidth: true
                    },
                }, sortable: true, filterable: true, minWidth: 40,
                // editor: {
                //   model: Editors.checkbox,
                // }
            },
            {
                id: 'level', name: 'Level', field: 'level', sortable: true, filterable: true, minWidth: 100,
            },
            {
                id: 'group_email',
                name: 'Support Group Mail',
                field: 'group_email',
                sortable: true,
                minWidth: 100,
                filterable: true,
                cssClass: 'highlight',
                editor: {
                    model: CustomInputEditor,
                }
            },
        ];

        this.messageService.setColumnDefinitions(columnDefinitions);
        if (this.messageService.clientId) {
            this.clientId = this.messageService.clientId;
            this.baseFlag = this.messageService.baseFlag;
            this.onPageLoad();
        } else {
            this.userAuth = this.messageService.getClientUserAuth().subscribe(auth => {
                this.view = auth[0].viewFlag;
                this.add = auth[0].addFlag;
                this.edit = auth[0].editFlag;
                this.del = auth[0].deleteFlag;
                this.clientId = auth[0].clientId;
                this.baseFlag = auth[0].baseFlag;
                this.onPageLoad();
            });
        }
    }

    onPageLoad() {
        this.getTableData();
    }

    changeRouting(path: string) {
        this.messageService.changeRouting(path);
    }

    get selectedOptions() {
        return this.days
            .filter(opt => opt.checked)
            .map(opt => opt.id);
    }

    openModal(content) {
        if (!this.messageService.add) {
            this.notifier.notify('error', 'You do not have add permission');
        } else {
            this.groupName = '';
            this.description = '';
            this.groupLevel = '1';
            this.snrMngmnt = false;
            this.reassignData();
            // this.zoneSelected = 0;

            this.modalService.open(content, {}).result.then((result) => {
            }, (reason) => {

            });
        }
    }

    hourToTimestamp(hour) {
        hour = hour + '';
        // console.log('hour=', hour);
        const hr = hour.substring(0, 2);
        const min = hour.substring(3, 5);
        // console.log(hr, min);
        const newDate = new Date().setHours(0, 0, 0, 0);
        // console.log('newDate', newDate);
        const hrInMilli = hr * 60 * 60 * 1000;
        const minInMilli = min * 60 * 1000;
        const total = newDate + hrInMilli + minInMilli;
        return total;
    }


    searchModal(){
            this.nameSelected = '';
            this.searchModalReference = this.modalService.open(this.scarch_content);
            this.searchModalReference.result.then((result) => {
            }, (reason) => {

            });
        
    }
    search() {
        this._rest.searchAllSupportGroup( this.nameSelected, this.clientId).subscribe((res1) => {
            this.respObject = res1;
            this.isLoading = false;
            if (this.respObject.success) {
                this.supprt = this.respObject.details;
                this.messageService.setTotalData(this.supprt.length);
                this.messageService.setGridData(this.supprt);
                this.searchModalReference.close();

            } else {
                this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
            this.isLoading = false;
            this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });
    }


    reassignData() {
        this.sunChck = false;
        this.monChck = false;
        this.tueChck = false;
        this.wedChck = false;
        this.thurChck = false;
        this.friChck = false;
        this.satChck = false;

        this.hoursStart = this.hours[0];
        this.hoursEnd = this.hours[0];
        this.minsStart = this.mins[0];
        this.minsEnd = this.mins[0];

        
        this.sunHourStart = '00:00';
        this.sunHourEnd = '00:00';
        this.monHourStart = '00:00';
        this.monHourEnd = '00:00';
        this.tueHourStart = '00:00';
        this.tueHourEnd = '00:00';
        this.wedHourStart = '00:00';
        this.wedHourEnd = '00:00';
        this.thurHourStart = '00:00';
        this.thurHourEnd = '00:00';
        this.friHourStart = '00:00';
        this.friHourEnd = '00:00';
        this.satHourStart = '00:00';
        this.satHourEnd = '00:00';


        this.sunHoursStart = this.hours[0];
        this.sunMinsStart = this.mins[0];
        this.sunHoursEnd = this.hours[0];
        this.sunMinsEnd = this.mins[0];
        this.monHoursStart = this.hours[0];
        this.monMinsStart = this.mins[0];
        this.monHoursEnd = this.hours[0];
        this.monMinsEnd = this.mins[0];
        this.tueHoursStart = this.hours[0];
        this.tueMinsStart =this.mins[0];
        this.tueHoursEnd = this.hours[0];
        this.tueMinsEnd = this.mins[0];
        this.wedHoursStart = this.hours[0];
        this.wedMinsStart = this.mins[0];
        this.wedHoursEnd = this.hours[0];
        this.wedMinsEnd = this.mins[0];
        this.thurHoursStart = this.hours[0];
        this.thurMinsStart = this.mins[0];
        this.thurHoursEnd = this.hours[0];
        this.thurMinsEnd = this.mins[0];
        this.friHoursStart = this.hours[0];
        this.friMinsStart = this.mins[0];
        this.friHoursEnd = this.hours[0];
        this.friMinsEnd = this.mins[0];
        this.satHoursStart = this.hours[0];
        this.satMinsStart = this.mins[0];
        this.satHoursEnd = this.hours[0];
        this.satMinsEnd = this.mins[0];
    

    }



    exportToExcel() {
        this.isExportDisable = true;

        // console.log("okkk" +this.clientId);
        this._rest.getAllSupportGroupData(this.clientId).subscribe((res1) => {
            this.respObject = res1;
            if (this.respObject.success) {
                this.isExportDisable = false;

                this.dataExcel = this.respObject.details;
                // console.log("true"+ JSON.stringify(this.dataExcel));
                this.messageService.exportAsExcelFile(this.dataExcel);
            } else {
                this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
            this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });
    }

    update() {
        if(this.sunChck){
            this.sunHourStart = this.sunHoursStart+":"+this.sunMinsStart;
            this.sunHourEnd = this.sunHoursEnd+":"+this.sunMinsEnd;
    
           }else{
            this.sunHourStart ='00:00';
            this.sunHourEnd = '00:00';
    
           }
           if(this.monChck){
            this.monHourStart = this.monHoursStart+":"+this.monMinsStart;
            this.monHourEnd = this.monHoursEnd+":"+this.monMinsEnd;
    
           }else{
            this.monHourStart = '00:00';
            this.monHourEnd = '00:00';
    
           }
            if(this.tueChck){
            this.tueHourStart = this.tueHoursStart+":"+this.tueMinsStart;
            this.tueHourEnd = this.tueHoursEnd+":"+this.tueMinsEnd;
    
           }else {
            this.tueHourStart = '00:00';
            this.tueHourEnd = '00:00';
    
           }
    
           if(this.wedChck){
            this.wedHourStart = this.wedHoursStart+":"+this.wedMinsStart;
            this.wedHourEnd = this.wedHoursEnd+":"+this.wedMinsEnd;
           }else {
            this.wedHourStart = '00:00';
            this.wedHourEnd = '00:00';
    
           }
           if(this.thurChck){
            this.thurHourStart = this.thurHoursStart+":"+this.thurMinsStart;
            this.thurHourEnd = this.thurHoursEnd+":"+this.thurMinsEnd;
    
           }else{
            this.thurHourStart = '00:00';
            this.thurHourEnd = '00:00';
    
           }
            if(this.friChck){
            this.friHourStart = this.friHoursStart+":"+this.friMinsStart;
            this.friHourEnd = this.friHoursEnd+":"+this.friMinsEnd;
    
           }else {
            this.friHourStart = '00:00';
            this.friHourEnd = '00:00';
    
           }
           if(this.satChck){
            this.satHourStart = this.satHoursStart+":"+this.satMinsStart;
            this.satHourEnd = this.satHoursEnd+":"+this.satMinsEnd;
    
           }else{
            this.satHourStart = '00:00';
            this.satHourEnd = '00:00';
    
           }
    
    
        
        if (this.hourChecked) {
            // console.log(this.selectedOptions);
            for (let i = 0; i < this.selectedOptions.length; i++) {
                if (this.selectedOptions[i] === 0) {
                    this.sunChck = true;
                    this.sunHourStart = this.hourStart;
                    this.sunHourEnd = this.hourEnd;
                }
                if (this.selectedOptions[i] === 1) {
                    this.monChck = true;
                    this.monHourStart = this.hourStart;
                    this.monHourEnd = this.hourEnd;
                }
                if (this.selectedOptions[i] === 2) {
                    this.tueChck = true;
                    this.tueHourStart = this.hourStart;
                    this.tueHourEnd = this.hourEnd;
                }
                if (this.selectedOptions[i] === 3) {
                    this.wedChck = true;
                    this.wedHourStart = this.hourStart;
                    this.wedHourEnd = this.hourEnd;
                }
                if (this.selectedOptions[i] === 4) {
                    this.thurChck = true;
                    this.thurHourStart = this.hourStart;
                    this.thurHourEnd = this.hourEnd;
                }
                if (this.selectedOptions[i] === 5) {
                    this.friChck = true;
                    this.friHourStart = this.hourStart;
                    this.friHourEnd = this.hourEnd;
                }
                if (this.selectedOptions[i] === 6) {
                    this.satChck = true;
                    this.satHourStart = this.hourStart;
                    this.satHourEnd = this.hourEnd;
                }
            }
        }
        let zoneId = 0;
        for (let i = 0; i < this.zones.length; i++) {
            if (this.zones[i].name === this.zoneSelected) {
                zoneId = this.zones[i].id;
            }
        }
        const data = {
            id:this.supp_Daytime_id,
            selectedId:this.selectedId,
            clientId: this.clientId, name: this.groupName, description: this.description,
            group_email: btoa(this.messageService.xorEncode(this.groupEmail, this.messageService.SECRET_TOKEN)),
            zoneId: zoneId, createdBy: this.messageService.getUserId(),
            groupLevel: Number(this.groupLevel),
            managemntView: this.snrMngmnt,
            sunChck: this.sunChck,
            sunHourStart: this.sunHourStart,
            sunHourEnd: this.sunHourEnd,
            monChck: this.monChck,
            monHourStart: this.monHourStart,
            monHourEnd: this.monHourEnd,
            tueChck: this.tueChck,
            tueHourStart: this.tueHourStart,
            tueHourEnd: this.tueHourEnd,
            wedChck: this.wedChck,
            wedHourStart: this.wedHourStart,
            wedHourEnd: this.wedHourEnd,
            thurChck: this.thurChck,
            thurHourStart: this.thurHourStart,
            thurHourEnd: this.thurHourEnd,
            friChck: this.friChck,
            friHourStart:this.friHourStart,
            friHourEnd: this.friHourEnd,
            satChck: this.satChck,
            satHourStart: this.satHourStart,
            satHourEnd: this.satHourEnd
        };

        if (data.sunChck === false && data.monChck === false && data.tueChck === false && data.wedChck === false && data.thurChck === false && data.friChck === false && data.satChck === false) {
            this.isError = true;
            this.notifier.notify('error', 'Please Select a day');
        } else {
            console.log('before validation data==' + JSON.stringify(data));
            // if (!this.validation(data)) {
                if (this.greaterfunc(data) === true) {
                    if (!this.messageService.isBlankField(
                        {
                            clientId: this.clientId,
                            groupName: this.groupName,
                            description: this.description,
                            zoneId: zoneId,
                            createdBy: this.messageService.getUserId(),
                            managemntView: this.snrMngmnt
                        }
                    )) {
                        this._rest.updateSupportGrpLevel(data).subscribe((res) => {
                            this.respObject = res;
                            if (this.respObject.success) {
                                this.isError = false;
                                this.nextOffset = 0;
                                this.page_no = 0;
                                this.modalReference.close();
                                this.getTableData();
                                this.notifier.notify('success', 'update successfully');
                            } else {
                                this.isError = true;
                                this.errorMessage = this.respObject.errorMessage;
                            }
                        }, (err) => {
                            this.isError = true;
                            this.errorMessage = this.messageService.SERVER_ERROR;
                        });
                        console.log(data);
                    } else {
                        this.isError = true;
                        this.errorMessage = this.messageService.BLANK_ERROR_MESSAGE;
                    }
                } else {
                    this.isError = true;
                    this.notifier.notify('error', 'End time should be greater than the Start time');
                }
            // } else {
            //     this.isError = true;
            //     this.notifier.notify('error', 'Blank Time fields');
            // }
        }
    }

    save() {


      this.hourStart = this.hoursStart+':'+this.minsStart;
      this.hourEnd = this.hoursEnd+':'+this.minsEnd;
       if(this.sunChck){
        this.sunHourStart = this.sunHoursStart+":"+this.sunMinsStart;
        this.sunHourEnd = this.sunHoursEnd+":"+this.sunMinsEnd;

       }else{
        this.sunHourStart ='00:00';
        this.sunHourEnd = '00:00';

       }
       if(this.monChck){
        this.monHourStart = this.monHoursStart+":"+this.monMinsStart;
        this.monHourEnd = this.monHoursEnd+":"+this.monMinsEnd;

       }else{
        this.monHourStart = '00:00';
        this.monHourEnd = '00:00';

       }
        if(this.tueChck){
        this.tueHourStart = this.tueHoursStart+":"+this.tueMinsStart;
        this.tueHourEnd = this.tueHoursEnd+":"+this.tueMinsEnd;

       }else {
        this.tueHourStart = '00:00';
        this.tueHourEnd = '00:00';

       }

       if(this.wedChck){
        this.wedHourStart = this.wedHoursStart+":"+this.wedMinsStart;
        this.wedHourEnd = this.wedHoursEnd+":"+this.wedMinsEnd;
       }else {
        this.wedHourStart = '00:00';
        this.wedHourEnd = '00:00';

       }
       if(this.thurChck){
        this.thurHourStart = this.thurHoursStart+":"+this.thurMinsStart;
        this.thurHourEnd = this.thurHoursEnd+":"+this.thurMinsEnd;

       }else{
        this.thurHourStart = '00:00';
        this.thurHourEnd = '00:00';

       }
        if(this.friChck){
        this.friHourStart = this.friHoursStart+":"+this.friMinsStart;
        this.friHourEnd = this.friHoursEnd+":"+this.friMinsEnd;

       }else {
        this.friHourStart = '00:00';
        this.friHourEnd = '00:00';

       }
       if(this.satChck){
        this.satHourStart = this.satHoursStart+":"+this.satMinsStart;
        this.satHourEnd = this.satHoursEnd+":"+this.satMinsEnd;

       }else{
        this.satHourStart = '00:00';
        this.satHourEnd = '00:00';

       }








        console.log("-----"+this.tueHoursStart+this.tueMinsStart)
        if (this.hourChecked) {
            // console.log(this.selectedOptions);
            for (let i = 0; i < this.selectedOptions.length; i++) {
                if (this.selectedOptions[i] === 0) {
                    this.sunChck = true;
                    this.sunHourStart = this.hourStart;
                    this.sunHourEnd = this.hourEnd;
                }
                if (this.selectedOptions[i] === 1) {
                    this.monChck = true;
                    this.monHourStart = this.hourStart;
                    this.monHourEnd = this.hourEnd;
                }
                if (this.selectedOptions[i] === 2) {
                    this.tueChck = true;
                    this.tueHourStart = this.hourStart;
                    this.tueHourEnd = this.hourEnd;
                }
                if (this.selectedOptions[i] === 3) {
                    this.wedChck = true;
                    this.wedHourStart = this.hourStart;
                    this.wedHourEnd = this.hourEnd;
                }
                if (this.selectedOptions[i] === 4) {
                    this.thurChck = true;
                    this.thurHourStart = this.hourStart;
                    this.thurHourEnd = this.hourEnd;
                }
                if (this.selectedOptions[i] === 5) {
                    this.friChck = true;
                    this.friHourStart = this.hourStart;
                    this.friHourEnd = this.hourEnd;
                }
                if (this.selectedOptions[i] === 6) {
                    this.satChck = true;
                    this.satHourStart = this.hourStart;
                    this.satHourEnd = this.hourEnd;
                }
            }
        }
        let zoneId = 0;
        for (let i = 0; i < this.zones.length; i++) {
            if (this.zones[i].name === this.zoneSelected) {
                zoneId = this.zones[i].id;
            }
        }
        const data = {
            clientId: this.clientId, groupName: this.groupName, description: this.description,
            group_email: btoa(this.messageService.xorEncode(this.groupEmail, this.messageService.SECRET_TOKEN)),
            zoneId: zoneId, createdBy: this.messageService.getUserId(),
            groupLevel: Number(this.groupLevel), managemntView: this.snrMngmnt,
            sunChck: this.sunChck,
            sunHourStart: this.sunHourStart,
            sunHourEnd: this.sunHourEnd,
            monChck: this.monChck,
            monHourStart: this.monHourStart,
            monHourEnd: this.monHourEnd,
            tueChck: this.tueChck,
            tueHourStart: this.tueHourStart,
            tueHourEnd: this.tueHourEnd,
            wedChck: this.wedChck,
            wedHourStart: this.wedHourStart,
            wedHourEnd: this.wedHourEnd,
            thurChck: this.thurChck,
            thurHourStart: this.thurHourStart,
            thurHourEnd: this.thurHourEnd,
            friChck: this.friChck,
            friHourStart:this.friHourStart,
            friHourEnd: this.friHourEnd,
            satChck: this.satChck,
            satHourStart: this.satHourStart,
            satHourEnd: this.satHourEnd
        };
        if (data.sunChck === false && data.monChck === false && data.tueChck === false && data.wedChck === false && data.thurChck === false && data.friChck === false && data.satChck === false) {
            this.isError = true;
            this.notifier.notify('error', 'Please Select a day');
        } else {
            console.log('before validation data==' + JSON.stringify(data));
            // if (!this.validation(data)) {
                if (this.greaterfunc(data) === true) {
                    if (!this.messageService.isBlankField(
                        {
                            clientId: this.clientId,
                            groupName: this.groupName,
                            description: this.description,
                            zoneId: zoneId,
                            createdBy: this.messageService.getUserId(),
                            managemntView: this.snrMngmnt
                        }
                    )) {
                        this._rest.insertSupportGrpLevel(data).subscribe((res) => {
                            this.respObject = res;
                            if (this.respObject.success) {
                                this.isError = false;
                                this.nextOffset = 0;
                                this.page_no = 0;
                                this.getTableData();
                                this.groupName = '';
                                this.description = '';
                                // this.parentSelected = 0;
                                this.groupLevel = '1';
                                this.snrMngmnt = false;
                                this.reassignData();
                                this.groupEmail = '';
                            } else {
                                this.isError = true;
                                this.errorMessage = this.respObject.errorMessage;
                            }
                        }, (err) => {
                            this.isError = true;
                            this.errorMessage = this.messageService.SERVER_ERROR;
                        });
                    } else {
                        this.isError = true;
                        this.errorMessage = this.messageService.BLANK_ERROR_MESSAGE;
                    }
                } else {
                    this.isError = true;
                    this.notifier.notify('error', 'End time should be greater than the Start time');
                }
            // } else {
            //     this.isError = true;
            //     this.notifier.notify('error', 'Blank Time fields');
            // }
        }
    }

    getTableData() {
        if (!this.messageService.view) {
            this.notifier.notify('error', 'You do not have view permission');
        } else {
            this.getData({'offset': this.nextOffset, 'paginationType': ''});
        }
    }

    isEmpty(obj) {
        for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
                return false;
            }
        }
        return true;
    }

    getData(paginationObj) {
        const offset = paginationObj.offset;
        const paginationType = paginationObj.paginationType;
        this.dataLoaded = false;
        this._rest.getSupportGrpLevel(this.clientId, offset, this.pageSize, paginationType).subscribe((res) => {
            this.respObject = res;
            this.executeResponse(this.respObject, offset, paginationType);
        }, (err) => {
            this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });
    }

    executeResponse(respObject, offset, paginationType) {
        if (respObject.success) {
            this.dataLoaded = true;
            if (offset === 0) {
                this.totalData = respObject.details.totalData[0].count;
                this.totalPage = respObject.details.totalPage;
                if (this.totalPage === 0) {
                    this.totalPage = 1;
                }
            }
            if (!this.isEmpty(respObject.details.dataObj)) {

                console.log('first' + JSON.stringify(respObject.details.dataObj));
                for (let i = 0; i < respObject.details.dataObj.length; i++) {
                    if (respObject.details.dataObj[i].group_email !== '') {
                        respObject.details.dataObj[i].group_email = this.messageService.xorEncode(atob(respObject.details.dataObj[i].group_email),
                            this.messageService.SECRET_TOKEN);
                    }
                }
                const data = respObject.details.dataObj;
                console.log('last' + JSON.stringify(data));
                this.nextOffset = respObject.details.nextOffset;
                this.offset = respObject.details.nextOffset;
                this.previousOffset = respObject.details.previousOffset;
                this.messageService.setTotalData(this.totalData);
                this.messageService.setGridData(data);
                // ----------------------------------------------
                if (offset !== 0) {
                    const totalCount = this.totalData;
                    const divRes = totalCount / this.pageSize;
                    const remainder = totalCount % this.pageSize;
                    if (remainder === 0) {
                        this.totalPage = parseInt(String(divRes), 10);
                    } else {
                        this.totalPage = parseInt(String(divRes), 10) + 1;
                    }
                }
                // ------------------------------------------------
                if (paginationType === 'next') {
                    this.page_no = this.page_no + 1;
                } else if (paginationType === 'prev') {
                    this.page_no = this.page_no - 1;
                } else if (paginationType === '' && this.page_no === 0) {
                    this.page_no = this.page_no + 1;
                }
                if (this.totalData <= this.pageSize * this.page_no) {
                    this.nextOffset = 0;
                }
            } else if (this.isEmpty(respObject.details.dataObj) && paginationType === 'next') {
                this.nextOffset = 0;
            } else if (this.isEmpty(respObject.details.dataObj) && paginationType === 'prev') {
                this.previousOffset = 0;
            } else if (paginationType === '' && this.page_no === 0) {
                this.page_no = this.page_no + 1;
            }
        } else {
            this.notifier.notify('error', respObject.errorMessage);
        }
    }


    onPageSizeChange(value: any) {
        this.page_no = 0;
        this.nextOffset = 0;
        this.pageSize = value;
        this.getData({'offset': this.nextOffset, 'paginationType': ''});
    }

    ngOnDestroy(): void {
        if (this.userAuth) {
            this.userAuth.unsubscribe();
        }
    }


    hourChange() {
        this.hourChecked = !this.hourChecked;
    }

    // validation(data) {
    //     console.log('validation data==' + JSON.stringify(data));
    //     if (data.sunChck === true && (data.sunHourEnd === '00:00' || data.sunHourStart === '00:00')) {
    //         return true;
    //     } else if (data.monChck === true && (data.monHourEnd === '00:00' || data.monHourStart === '00:00')) {
    //         return true;
    //     } else if (data.tueChck === true && (data.tueHourEnd === '00:00' || data.tueHourStart === '00:00')) {
    //         return true;
    //     } else if (data.wedChck === true && (data.wedHourEnd === '00:00' || data.wedHourStart === '00:00')) {
    //         return true;
    //     } else if (data.thurChck === true && (data.thurHourEnd === '00:00' || data.thurHourStart === '00:00')) {
    //         return true;
    //     } else if (data.friChck === true && (data.friHourEnd === '00:00' || data.friHourStart === '00:00')) {
    //         return true;
    //     } else if (data.satChck === true && (data.satHourEnd === '00:00' || data.satHourStart === '00:00')) {
    //         return true;
    //     } else {
    //         return false;
    //     }
    // }

    greaterfunc(data) {
        if (this.sunChck === true && (data.sunHourStart >= data.sunHourEnd)) {
            return false;
        } else if (this.monChck === true && (data.monHourStart >= data.monHourEnd)) {
            return false;
        } else if (this.tueChck === true && (data.tueHourStart >= data.tueHourEnd)) {
            return false;
        } else if (this.wedChck === true && (data.wedHourStart >= data.wedHourEnd)) {
            return false;
        } else if (this.thurChck === true && (data.thurHourStart >= data.thurHourEnd)) {
            return false;
        } else if (this.satChck === true && (data.satHourStart >= data.satHourEnd)) {
            return false;
        } else if (this.friChck === true && (data.friHourStart >= data.friHourEnd)) {
            return false;
        } else {
            return true;
        }
    }

    timeFormat(date) {
        if (date !== null && date !== 0 && date !== undefined) {
            const d = new Date(date);
            const hour = d.getHours();
            const min = d.getMinutes();
            let nHour, nMin;
            if (hour < 10) {
                nHour = '0' + hour;
            } else {
                nHour = hour;
            }
            if (min < 10) {
                nMin = '0' + min;
            } else {
                nMin = min;
            }
            return nHour + ':' + nMin;
        } else {
            return '00:00';
        }
    }
}
